import React from 'react';
import T from 'prop-types';
import { isEmpty, isEqual } from 'lodash-es';

import WarningNotification from '../WarningNotification';
import CheckboxGroup from '../../../CheckboxGroup';

import { userSegmentsOptions } from '../../configs/report';

const UserSegments = ({
  active,
  panelVersion,
  activeDataPoints,
  disabledNotCrossApp,
  onChange,
}) => (
  <section className="export-settings-section user-segments-section">
    <div className="export-settings-section__content">
      <h5 className="h5 export-settings-section__content-title">User Segments</h5>
      <CheckboxGroup
        id="user-segments-checkboxes"
        active={active}
        options={userSegmentsOptions(panelVersion, disabledNotCrossApp)}
        className="export-settings-section__options export-form-checkbox-group user-segments-options three-columns m-b-xs"
        gapCheckbox="8px"
        size="lg"
        onChange={onChange}
      />

      {isEmpty(active) && <WarningNotification text="At least one user segment must be selected" />}
      {activeDataPoints.includes('time_spent_segment_penetration') && isEqual(active, ['all']) && <WarningNotification text="At least one user segment other than 'All Users' must be selected" />}
      {!isEmpty(activeDataPoints?.filter(item => item.startsWith('cross_app')))
        && !active.some(a => a === 'all_users') && <WarningNotification text="For Cross-App reports, 'All Users' must be selected" />}
    </div>
  </section>
);

UserSegments.propTypes = {
  active: T.array.isRequired,
  panelVersion: T.string.isRequired,
  activeDataPoints: T.array.isRequired,
  onChange: T.func.isRequired,
  disabledNotCrossApp: T.bool.isRequired,
};

export default UserSegments;
